import React from 'react';
import getColor from '../../../utils/interpolateColor.js';
import { getProgressBarFillPercent } from '../../../utils/progressBarDisplayWidth.js';
// import ParameterIcon from '../../../components/ParameterIcon.jsx';
import { useTranslation } from '../../../hooks/useTranslation.js';

// Component for individual parameter (matches the expected interface)
const ProgressBarComponent = ({ name, score, bonus}) => {
  const totalScore = (score || 0) + (bonus?.value || 0);
  const clamped = Math.max(0, Math.min(100, totalScore));
  const barColor = getColor(clamped);
  const percentage = getProgressBarFillPercent(clamped);
  const { t } = useTranslation();

  return (
    <div className="relative w-full rounded-full border border-gray-200 bg-gray-100 overflow-hidden mb-2">
      <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${percentage}%`, backgroundColor: barColor }} />
      <div className="relative z-10 flex items-center justify-between" style={{ padding: '0 6px 0 0' }}>
        <div className="flex items-center space-x-3 py-2 px-3">
          <span className="text-sm font-semibold text-gray-900">{t(name)}</span>
        </div>
        <span className="text-sm font-black text-gray-900">{Math.round(clamped)}/100</span>
      </div>
    </div>
  );
};


export default ProgressBarComponent;